import { render, staticRenderFns } from "./UpdateItemPopup.vue?vue&type=template&id=49b24b3e&"
import script from "./UpdateItemPopup.vue?vue&type=script&lang=js&"
export * from "./UpdateItemPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\270b-ariq\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b24b3e')) {
      api.createRecord('49b24b3e', component.options)
    } else {
      api.reload('49b24b3e', component.options)
    }
    module.hot.accept("./UpdateItemPopup.vue?vue&type=template&id=49b24b3e&", function () {
      api.rerender('49b24b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/allocation/UpdateItemPopup.vue"
export default component.exports